<template>
  <main class="">
    <v-parallax src="/static/back.jpg" :height="300">
      <v-container class="white-text center-align">
        <h3>Minecraft<br class="hide-on-med-and-up">同人サークル</h3>
        <h2>{{ $t('top.circle_name') }}</h2>
        <v-row>
          <v-grid s12>
            <v-btn-link class="waves-effect waves-light" :large=true href="#modal">{{ $t('top.whats_doujin') }}</v-btn-link>
          </v-grid>
        </v-row>
      </v-container>
    </v-parallax>
    <v-container class="promo-outer">
      <v-row>
        <v-grid s12 m6>
          <div class="promo">
            <img src="/static/svg/webdesign/startup.svg">
            <p class="promo-caption">プレイ人口増加</p>
            <p class="promo-info">
              私たちは、マインクラフトという素晴らしいゲームが大好きです。
              今日、遊び以外にも学問や研究分野で使用されるなど、幅広く関心を集めています。
              関心を持つ人たちを、遊びにつなげることができれば、
              マインクラフトをもっと盛り上げることができます。<br>
              私たちは、マインクラフトを遊ぶ人たちを増やします。
            </p>
          </div>
        </v-grid>
        <v-grid s12 m6>
          <div class="promo">
            <img src="/static/svg/webdesign/brainstorming.svg">
            <p class="promo-caption">ファンが集う場所</p>
            <p class="promo-info">
              マインクラフトの情報源やコミュニティは、インターネット上に散在しています。
              もっとマインクラフトを盛り上げるためには、幅広く情報がまとめられている
              場所が必要です。そして、日本中のマインクラフトファンが楽しめる場所を提供する
              ことはとても重要です。<br>
              私たちは、良質な情報とコミュニティを提供します。
            </p>
          </div>
        </v-grid>
      </v-row>
    </v-container>
  </main>
</template>

<script>
export default {
  name: 'top',
  head: {
    title: {
      inner: 'トップ'
    }
  }
}
</script>


// WEBPACK FOOTER //
// Top.vue?3a25c2d7